import { CheckOutlined, InfoCircleOutlined, PaperClipOutlined } from "@ant-design/icons";
import { Badge, Button, Select, Tooltip, Typography } from "antd";
import React from "react";
import { leaseService } from "../../../../configs/constants";
import { GridType } from "../../../../types/grid";
import axios from "../../../../utils/axiosInceptor";
import { dateByformat } from "../../../../utils/dateHelper";
import { isReceiptsModuleEnabled } from "../../../../utils/isReceiptsModuleEnabled";
import { PopupConfirm } from "../../../atoms/Popup";
import { convertToTitleCase, formatCurrency, formatDateByType, formatNumber } from "../../../libs/utils";
import { CurrencyExchangeIcon, dateOfDaysBeforeDue, gussAutoPayIsOn } from "../../BookingForm/components/utils";
import { setActionOptions } from "../utili";

const RECEIPT_ONLY_ACTIONS = new Set([
  "mark_as_bounced",
  "mark_cleared",
  "defer_cheque_deposit",
  "approve_pending_request",
  "reject_pending_request",
  "recallCheque",
  "approveRejectRecallCheque",
  "approveRejectReceipt",
]);

export let columnDefs: GridType[] = [
  {
    id: "invoiceNumber",
    field: "invoiceNumber",
    headerName: "Invoice no.",
    checked: true,
    hide: false,
  },
  {
    id: 101,
    headerName: "Request Type",
    field: "requestType",
    checked: true,
    hide: false,
  },
  {
    id: 1011,
    headerName: "Deposit Date",
    field: "depositDate",
    checked: true,
    hide: false,
  },
  {
    id: 777,
    headerName: "Deferred Date",
    field: "deferredDate",
    checked: true,
    hide: false,
  },
  {
    id: 1,
    headerName: "",
    field: "Attachments",
    checked: true,
    hide: false,
  },
  {
    id: 2,
    headerName: "Property",
    field: "propertyDetails.propertyName",
    checked: true,
    hide: false,
  },
  {
    id: 3,
    headerName: "Tenant Name",
    field: "tenantDetails.tenantNameEN",
    checked: true,
    hide: false,
  },
  {
    id: 4,
    headerName: "Unit Number",
    field: "propertyDetails.unitNumber",
    width: 240,
    checked: true,
    hide: false,
  },
  {
    id: 5,
    headerName: "Lease Term",
    field: "leaseTerms",
    checked: true,
    hide: false,
  },
  {
    id: 6,
    headerName: "Unit Code",
    field: "unitCode",
    width: 300,
    checked: true,
    hide: false,
  },
  {
    id: "invoiceDate",
    field: "invoiceDate",
    headerName: "Invoice Date",
    checked: true,
    hide: false,
  },
  {
    id: 7,
    headerName: "Due Date",
    field: "dueDate",
    checked: true,
    hide: false,
  },
  {
    id: 8,
    headerName: "Payment Type",
    field: "description",
    checked: true,
    hide: false,
  },
  {
    id: 9,
    headerName: "Installment No",
    field: "installmentNo",
    checked: true,
    hide: false,
  },
  {
    id: 10,
    headerName: "Payment Mode",
    field: "modeOfPayment",
    checked: true,
    hide: false,
  },
  {
    id: 11,
    headerName: "Bank Name",
    field: "bankName",
    checked: true,
    hide: false,
  },
  {
    id: 12,
    headerName: "Payment Ref",
    field: "documentNo",
    checked: true,
    hide: false,
  },
  {
    id: 13,
    headerName: "Cheque Date",
    field: "chequeDate",
    checked: true,
    hide: false,
  },
  {
    id: 14,
    headerName: "Amount",
    field: "actualAmount",
    checked: true,
    hide: false,
  },
  {
    id: "vat",
    field: "vat",
    headerName: "VAT",
    checked: true,
    hide: false,
  },
  {
    id: "vatInPercentage",
    field: "vatInPercentage",
    headerName: "VAT %",
    checked: true,
    hide: false,
  },
  {
    id: "totalAmount",
    field: "totalAmount",
    headerName: "Total Amount",
    checked: true,
    hide: false,
  },
  {
    id: "balance",
    field: "balance",
    headerName: "Balance",
    checked: true,
    hide: false,
  },
  {
    id: "invoiceAmount",
    field: "invoiceAmount",
    headerName: "Base Rent",
    checked: true,
    hide: false,
  },
  {
    id: "torAmount",
    field: "torAmount",
    headerName: "TOR Amount",
    checked: true,
    hide: false,
  },
  {
    id: "invoicingPattern",
    field: "invoicingPattern",
    headerName: "Invoicing Pattern",
    checked: true,
    hide: false,
  },
  {
    id: 15,
    headerName: "Receipt Date",
    field: "receiptDate",
    checked: true,
    hide: false,
  },
  {
    id: 16,
    headerName: "Payment Status",
    field: "chequeStatus",
    checked: true,
    hide: false,
  },
  {
    id: 17,
    headerName: "Reason",
    field: "reason",
    checked: true,
    hide: false,
  },
  {
    id: 18,
    headerName: "Beneficiary Name",
    field: "beneficiaryName",
    checked: false,
    hide: true,
  },
  {
    id: 19,
    headerName: "Owner Name",
    field: "ownerName",
    checked: false,
    hide: true,
  },
  {
    id: 20,
    headerName: "Lessor Name",
    field: "lessorName",
    checked: false,
    hide: true,
  },
  {
    id: 21,
    headerName: "Beneficiary Bank",
    field: "beneficiaryBank",
    checked: false,
    hide: true,
  },
  {
    id: 22,
    headerName: "Beneficiary Account",
    field: "beneficiaryAccount",
    checked: false,
    hide: true,
  },
  {
    id: 23,
    headerName: "Beneficiary IBAN",
    field: "beneficiaryIBAN",
    checked: false,
    hide: true,
  },
  {
    id: 25,
    headerName: "Period To",
    field: "itemEndDate",
    checked: false,
    hide: true,
  },
  {
    id: 26,
    headerName: "Period From",
    field: "itemStartDate",
    checked: false,
    hide: true,
  },
  {
    id: 124,
    headerName: "Receipt No",
    field: "receiptNo",
    checked: true,
    hide: false,
  },
  {
    id: "creditNoteNumber",
    field: "creditNoteNumber",
    headerName: "Credit Note No",
    checked: true,
    hide: false,
  },
  {
    id: "erpTenantId",
    field: "erpTenantId",
    headerName: "ERP Customer Id",
    checked: true,
    hide: false,
  },
  {
    id: "erpReceipts",
    field: "erpReceipts",
    headerName: "ERP Receipt Id",
    checked: true,
    hide: false,
  },
  {
    id: "erpInvoiceNumber",
    field: "erpInvoiceNumber",
    headerName: "ERP Invoice Id",
    checked: true,
    hide: false,
  },
  {
    id: 125,
    headerName: "Action",
    field: "action",
    checked: true,
    hide: false,
  },
  {
    id: "isCleared",
    field: "isCleared",
    headerName: "Cleared Status",
    checked: true,
    hide: false,
  },
  {
    id: "clearedDate",
    field: "clearedDate",
    headerName: "Clearing Date",
    checked: true,
    hide: false,
  },
  {
    id: "yearNumber",
    headerName: "Year",
    field: "yearNumber",
    checked: true,
    hide: false,
  },
  {
    id: "sendStatus",
    field: "sendStatus",
    headerName: "Send Status",
    checked: true,
    hide: false,
  },
  {
    id: "totalReceiptAmount",
    field: "totalReceiptAmount",
    headerName: "Receipt Amount",
    checked: true,
    hide: false,
  },
  {
    id: "latestPaymentReceiptDate",
    field: "latestPaymentReceiptDate",
    headerName: "Last Receipt Date",
    checked: true,
    hide: false,
  },
  {
    id: "bounceDate",
    field: "bounceDate",
    headerName: "Bounce Date",
    checked: true,
    hide: false,
  },
  { id: "cnAmount", field: "cnAmount", headerName: "CN Amount", checked: true, hide: false },
];

const downLoadDocument = async (id) => {
  const url = `${leaseService}/document/getDocument/${id}?preview=true`;

  try {
    const response = await axios.get(url, {
      headers: {
        "bussiness-unit": "AUTO",
        accept: "*/*",
        "organization-unit": "AGP",
        channel: "MOBILE",
        "accept-language": "EN",
        source: "Orion",
      },
    });

    let { data } = response;

    var link = document.createElement("a");
    link.target = "_blank";
    link.href = data?.result?.location;
    link.dispatchEvent(new MouseEvent("click"));
  } catch (error) {}
};

const convertToNormalCase = (input = "") => {
  if (["directDebit", "directdebit"].includes(input)) {
    return "Direct Debit";
  }
  // Check if the input is in camel case
  if (input?.indexOf("_") === -1 && input !== input?.toLowerCase()) {
    return input?.replace(/([a-z])([A-Z])/g, "$1 $2")?.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  // Check if the input is in snake case
  if (input?.indexOf("_") !== -1) {
    return input?.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
  }

  return input?.charAt(0).toUpperCase() + input?.slice(1); // Already in normal case
};

const convertToNormalCaseRemoveNumber = (input = "") => {
  // Remove numbers if the input consists of any number
  if (/^\d+$/.test(input)) {
    return "";
  }

  // Remove numbers from the input
  input = input.replace(/\d+/g, "");

  // Check if the input is in camel case
  if (input.indexOf("_") === -1 && input !== input.toLowerCase()) {
    return input.replace(/([a-z])([A-Z])/g, "$1 $2");
  }

  // Check if the input is in snake case
  if (input.indexOf("_") !== -1) {
    return input.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
  }

  return input.charAt(0).toUpperCase() + input.slice(1); // Already in normal case
};

function viewStatusRender(record) {
  const statusLabel: any = convertToNormalCase(record.data.chequeStatus);

  if (record.data.chequeStatus === "paid") {
    return (
      <>
        <span>{statusLabel}</span>
      </>
    );
  } else {
    return <span>{statusLabel}</span>;
  }
}

function receiptNoRender(record: any) {
  const subPdcs = record?.data?.subPdcs ?? [];
  const overpaymentInvoices = record?.data?.overpaymentInvoices ?? [];
  const moveoutcreditnotes = record?.data?.moveoutcreditnotes ?? [];
  // Normalize all receipts into one structure
  const paidReceipts = [
    ...subPdcs
      .filter((pdc: any) => pdc?.status?.toLowerCase() === "paid" && pdc?.paymentReceiptId)
      .map((pdc: any) => ({
        key: pdc?.subPdcId ?? pdc?.paymentReceiptId,
        receiptNo: pdc?.receiptNo,
        paymentReceiptId: pdc?.paymentReceiptId,
        isCleared: pdc?.isCleared,
      })),

    ...overpaymentInvoices.map((item: any) => ({
      key: item?.documentId,
      receiptNo: item?.receiptNumber,
      paymentReceiptId: item?.documentId,
      isCleared: false,
    })),

    ...moveoutcreditnotes.map((item: any) => ({
      key: item?.documentId,
      receiptNo: item?.receiptNumber,
      paymentReceiptId: item?.documentId,
      isCleared: false,
    })),
  ];

  // Fallback single receipt
  if (record?.data?.paymentReceiptId && subPdcs?.length === 0) {
    paidReceipts.push({
      key: record.data.paymentReceiptId,
      receiptNo: record.data.receiptNo,
      paymentReceiptId: record.data.paymentReceiptId,
      isCleared: record.data.isCleared,
    });
  }
  paidReceipts?.sort((a, b) =>
    String(a.receiptNo ?? "").localeCompare(String(b.receiptNo ?? ""), undefined, { numeric: true }),
  );
  if (paidReceipts.length === 0) return null;

  const visibleReceipts = paidReceipts.filter((item: any) => item.receiptNo && item.receiptNo !== "");
  if (visibleReceipts.length === 0) return null;

  return (
    <>
      {visibleReceipts.map((item: any, index: number) => (
        <span key={item.key} style={{ display: "inline-flex", alignItems: "center" }}>
          {item.isCleared && <CheckOutlined style={{ color: "green" }} />}

          <Button
            type="link"
            className="ag-primary"
            style={{ padding: 0 }}
            title={`Click to download receipt no ${item.receiptNo}`}
            onClick={() => downLoadDocument(item.paymentReceiptId)}
          >
            {`Rec_${item.receiptNo}`}
            {index !== visibleReceipts.length - 1 && ", "}
          </Button>
        </span>
      ))}
    </>
  );
}

export const pdcColumn = (
  gracePeriodDays,
  PaymentModeOptions,
  setPaymentStatusInfo,
  setVisible,
  setSelectedPDC,
  setCreditNoteAction,
  paymentColumns,
  openPrintInvoiceModal,
  onClickGenerateInvoiceOrTor,
  onClickRejectTransfer,
  organization,
  canChequeCleared = false,
  canApproveReceipts = false,
  setRecallChequeActionType,
) => {
  const { Text } = Typography;

  const updatePaymentInfo = (rowData, selectedOption, status, index) => {
    setPaymentStatusInfo({
      paymentMode: rowData?.data?.modeOfPayment,
      params: rowData,
      isNew: true,
      selectedOption: selectedOption,
    });

    index && setVisible({ status: status, index: index });
  };

  const selectedOptions = ["confirm_payment", "mark_as_bounced", "cancelled"];

  function MoreAction(row) {
    const onChangeHandler = async (e) => {
      if (e && row?.data.chequeStatus) {
        let rowData = { ...row };
        rowData.data.bounceToPending = false;
        rowData.data.currentStaus = rowData.data.chequeStatus;

        if (selectedOptions.includes(e)) {
          updatePaymentInfo(rowData, e, true, 2);
        } else if (e === "applyCreditNote" || e === "approveOrRejectCreditNote") {
          setSelectedPDC(row?.data);
          setCreditNoteAction(e === "approveOrRejectCreditNote" ? "approveReject" : "apply");
          setVisible({ status: true, index: 6 });
        } else if (e === "replace_cheque" && rowData.data.chequeStatus === "bounce") {
          rowData.data.bounceToPending = true;
          updatePaymentInfo(rowData, e, true, 2);
        } else if (e === "defer_cheque_deposit" || e === "approve_pending_request" || e === "reject_pending_request") {
          updatePaymentInfo(rowData, e, true, 5);
        } else if (e === "history") {
          updatePaymentInfo(rowData, e, false, null);
        } else if (e === "generateTor") {
          await onClickGenerateInvoiceOrTor(row?.data?.pdcId);
        } else if (e === "rejectTransfer") {
          PopupConfirm({
            title: "Are you sure you want to reject this bank transfer?",
            content: "",
            okText: "Confirm",
            onOk: async () => {
              await onClickRejectTransfer?.(row?.data);
            },
          });
        } else if (e === "viewTorLedger") {
          setVisible({ status: true, index: 3 });
          setSelectedPDC(row?.data);
        } else if (e === "printInvoice") {
          openPrintInvoiceModal(row?.data?.pdcId);
        } else if (e === "recallCheque") {
          setRecallChequeActionType("apply");
          setVisible({ status: true, index: 8 });
          setSelectedPDC(row?.data);
        } else if (e === "approveRejectRecallCheque") {
          setRecallChequeActionType("approveReject");
          setVisible({ status: true, index: 8 });
          setSelectedPDC(row?.data);
        } else if (e === "mark_cleared") {
          updatePaymentInfo(rowData, e, true, 7);
        } else if (e === "approveRejectReceipt") {
          updatePaymentInfo(rowData, e, true, 9);
        } else {
          updatePaymentInfo(rowData, e, true, 2);
        }
      }
    };

    return (
      <Select
        onChange={onChangeHandler}
        className="Sentence"
        placeholder="Select an action"
        style={{ width: 150 }}
        value={null}
        allowClear
      >
        {(() => {
          const baseOptions = setActionOptions(row, organization, canChequeCleared, canApproveReceipts);
          return isReceiptsModuleEnabled(organization)
            ? baseOptions?.filter((opt: any) => !RECEIPT_ONLY_ACTIONS.has(opt?.value))
            : baseOptions;
        })()?.map((option) => {
          return (
            <React.Fragment key={option?.id}>
              {!option?.hidden && (
                <Select.Option disabled={option?.hidden} value={option?.value}>
                  <Text>{option?.label}</Text>
                </Select.Option>
              )}
            </React.Fragment>
          );
        })}
      </Select>
    );
  }

  const viewPaymentAttachment = (item) => {
    setSelectedPDC(item);
    setVisible({ status: true, index: 0 });
  };

  function viewAttchements(data) {
    return (
      <>
        <Button
          size="small"
          icon={<PaperClipOutlined />}
          onClick={() => {
            viewPaymentAttachment(data);
          }}
          type="link"
          className={"ag-primary " + (data?.documentId ? "button-active" : "button-inactive")}
        />
        {gussAutoPayIsOn(data?.description, data?.chequeStatus, data?.isAutoPayActive, data?.paidFrom) && (
          <Tooltip
            title={`Scheduled for autopay on ${
              gracePeriodDays && dateOfDaysBeforeDue(dateByformat(data.chequeDate, "DD-MM-YYYY"), gracePeriodDays)
            }`}
          >
            <Badge
              title="AutoPay"
              count={<CurrencyExchangeIcon width="25px" height="25px" />}
              style={{ position: "relative", bottom: "2px", backgroundColor: "white", zIndex: 9999 }}
            />
          </Tooltip>
        )}
      </>
    );
  }

  return paymentColumns.map((col) => {
    if (col.field === "invoiceNumber") {
      return {
        ...col,
        minWidth: 200,
        flex: 1,
        headerCheckboxSelection: true,
        checkboxSelection: ({ data }) => data?.chequeStatus === "pending",
        cellRendererFramework: ({ value, data }) => (
          <>
            <span>{value}</span>
            {data?.lowtorledgereporthightlight && (
              <Tooltip title="TOR entries are missing for this invoice">
                <InfoCircleOutlined style={{ paddingLeft: 16, color: "red" }} />
              </Tooltip>
            )}
          </>
        ),
      };
    } else if (col.field === "requestType") {
      return {
        ...col,
        minWidth: 200,
        flex: 1,
        cellRendererFramework: ({ data }) => {
          if (data?.deferredRequest === "pending") return "Deferred";
          if (data?.creditNote?.status === "pending") return "Credit Note";
          if (data?.recallChequeRequestStatus === "pending") return "Cheque Recall";
          if (data?.receiptApprovalRequest === "pending") return "Receipt Request";
          return null;
        },
      };
    } else if (col.field === "deferredDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => {
          return dateByformat(data.deferredDate, "DD-MM-YYYY");
        },
      };
    } else if (col.field === "Attachments") {
      return {
        ...col,
        cellRendererFramework: viewAttchements,
        cellStyle: { textAlign: "center", padding: "0" },
        maxWidth: 60,
      };
    } else if (col.field === "leaseTerms") {
      return {
        ...col,
        cellRendererFramework: ({ data }) =>
          `(${dateByformat(data?.leaseTerms?.leaseStartDate, "DD-MM-YYYY")} - ${dateByformat(
            data?.leaseTerms?.leaseEndDate,
            "DD-MM-YYYY",
          )})`,
        width: "300",
      };
    } else if (col.field === "invoiceDate") {
      return {
        ...col,
        valueFormatter: ({ value }) => formatDateByType(value),
      };
    } else if (col.field === "dueDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => {
          return dateByformat(data.dueDate, "DD-MM-YYYY");
        },
      };
    } else if (col.field === "depositDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => {
          return dateByformat(data.depositDate, "DD-MM-YYYY");
        },
      };
    } else if (col.field === "latestPaymentReceiptDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => {
          return dateByformat(data.latestPaymentReceiptDate, "DD-MM-YYYY");
        },
      };
    } else if (col.field === "bounceDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => {
          return dateByformat(data.bounceDate, "DD-MM-YYYY");
        },
      };
    } else if (col.field === "description") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => {
          return `${convertToNormalCaseRemoveNumber(data.description)}`;
        },
      };
    } else if (col.field === "installmentNo") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => {
          const isRentInstallment = data.description === "rent_installment";
          // const totalInstallments = data.leaseTerms?.noOfCheques || 1;
          const installmentNo = data.installments || 1;
          // return isRentInstallment ? `${installmentNo}/${totalInstallments}` : "--";
          return isRentInstallment ? `${installmentNo}` : "--";
        },
      };
    } else if (col.field === "modeOfPayment") {
      return {
        ...col,
        cellEditor: "agSelectCellEditor",
        editable: ({ data }) => (data.chequeStatus === "paid" ? false : true),
        cellRendererFramework: ({ data }) => convertToNormalCase(data.modeOfPayment),
        cellEditorParams: ({ data }) => {
          var modeOfPayment = data.modeOfPayment;
          let PaymentModeOptionsTemp = PaymentModeOptions.filter(
            (paymentModeOption) => paymentModeOption !== modeOfPayment,
          );

          PaymentModeOptionsTemp.unshift(modeOfPayment);
          PaymentModeOptionsTemp = PaymentModeOptionsTemp.map((paymentModeOption) =>
            convertToNormalCase(paymentModeOption),
          );

          return { values: PaymentModeOptionsTemp };
        },
      };
    } else if (col.field === "bankName") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => {
          return data.bankName ? `${convertToNormalCase(data.bankName)}` : "";
        },
      };
    } else if (col.field === "chequeDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => {
          return data?.chequeDate ? dateByformat(data.chequeDate, "DD-MM-YYYY") : "--";
        },
      };
    } else if (col.field === "actualAmount") {
      return {
        ...col,
        minWidth: 170,
        flex: 1,
        type: "rightAligned",
        cellRendererFramework: ({ value }) => formatCurrency(value),
      };
    } else if (col.field === "totalAmount") {
      return {
        ...col,
        minWidth: 170,
        flex: 1,
        type: "rightAligned",
        cellRendererFramework: ({ value }) => formatCurrency(value),
      };
    } else if (col.field === "balance") {
      return {
        ...col,
        minWidth: 170,
        flex: 1,
        type: "rightAligned",
        cellRendererFramework: ({ value }) => formatCurrency(value),
      };
    } else if (col.field === "receiptAmount") {
      return {
        ...col,
        minWidth: 170,
        flex: 1,
        type: "rightAligned",
        cellRendererFramework: ({ value }) => formatCurrency(value || 0),
      };
    } else if (col.field === "cnAmount") {
      return {
        ...col,
        minWidth: 170,
        flex: 1,
        type: "rightAligned",
        cellRendererFramework: ({ value }) => formatCurrency(value || 0),
      };
    } else if (col.field === "totalReceiptAmount") {
      return {
        ...col,
        minWidth: 170,
        flex: 1,
        type: "rightAligned",
        cellRendererFramework: ({ value }) => formatCurrency(value || 0),
      };
    } else if (col.field === "invoiceAmount") {
      return {
        ...col,
        flex: 1,
        minWidth: 170,
        type: "rightAligned",
        cellRendererFramework: ({ value }) => formatCurrency(value),
      };
    } else if (col.field === "torAmount") {
      return {
        ...col,
        flex: 1,
        minWidth: 150,
        type: "rightAligned",
        cellRendererFramework: ({ data }) => formatCurrency(data?.torSummary?.totalRent),
      };
    } else if (col.field === "vat") {
      return {
        ...col,
        flex: 1,
        minWidth: 150,
        type: "rightAligned",
        cellRendererFramework: ({ value }) => formatNumber(value),
      };
    } else if (col.field === "vatInPercentage") {
      return {
        ...col,
        flex: 1,
        minWidth: 150,
        type: "rightAligned",
        cellRendererFramework: ({ value }) => formatNumber(value),
      };
    } else if (col.field === "sendStatus") {
      return {
        ...col,
        flex: 1,
        minWidth: 130,
        valueFormatter: ({ data }) => convertToTitleCase(data?.sendStatus),
      };
    } else if (col.field === "invoicingPattern") {
      return {
        ...col,
        flex: 1,
        minWidth: 190,
        valueFormatter: ({ data }) => convertToTitleCase(data?.invoicingPattern),
      };
    } else if (col.field === "receiptDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => {
          return data?.paidDate ? dateByformat(data.paidDate, "DD-MM-YYYY") : "";
        },
      };
    } else if (col.field === "chequeStatus") {
      return {
        ...col,
        // editable: ({ data }) => (data.chequeStatus === "paid" ? false : true),
        // cellEditor: "agSelectCellEditor",
        cellRendererFramework: viewStatusRender,
        // cellEditorParams: ({ data }) => {
        //   if (data?.modeOfPayment?.toLowerCase() === "cheque") {
        //     if (data.chequeStatus?.toLowerCase() === "bounce") {
        //       return {
        //         values: ["select", "paid", "cancelled"],
        //       };
        //     } else {
        //       return {
        //         values: ["select", "pending", "paid", "bounce", "cancelled"],
        //       };
        //     }
        //   } else {
        //     return {
        //       values: ["select", "pending", "paid", "cancelled"],
        //     };
        //   }
        // },
      };
    } else if (col.field === "reason") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => (data.reason === "select" ? "--" : convertToNormalCase(data.reason)),
      };
    } else if (col.field === "itemEndDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => {
          return data?.itemEndDate ? dateByformat(data.itemEndDate, "DD-MM-YYYY") : "--";
        },
      };
    } else if (col.field === "itemStartDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => {
          return data?.itemStartDate ? dateByformat(data.itemStartDate, "DD-MM-YYYY") : "--";
        },
      };
    } else if (col.field === "receiptNo") {
      return {
        ...col,
        cellRendererFramework: receiptNoRender,
        maxWidth: 400,
      };
    } else if (col.field === "creditNoteNumber") {
      return {
        ...col,
        cellRendererFramework: ({ value }) => {
          if (Array.isArray(value)) return value.join(", ");
          return value || "--";
        },
      };
    } else if (col.field === "erpTenantId") {
      return {
        ...col,
        cellRendererFramework: ({ value }) => value || "--",
      };
    } else if (col.field === "erpReceipts") {
      return {
        ...col,
        cellRendererFramework: ({ value }) => {
          if (Array.isArray(value)) return value.filter(Boolean).join(", ") || "--";
          return value || "--";
        },
      };
    } else if (col.field === "erpInvoiceNumber") {
      return {
        ...col,
        cellRendererFramework: ({ value }) => value || "--",
      };
    } else if (col.field === "isCleared") {
      return {
        ...col,
        minWidth: 200,
        flex: 1,
        cellRendererFramework: ({ value }) => (
          <>
            <span>{value ? "Cleared" : "Not Cleared"}</span>
          </>
        ),
      };
    } else if (col.field === "clearedDate") {
      return {
        ...col,
        minWidth: 200,
        flex: 1,
        valueFormatter: ({ value }) => dateByformat(value, "DD-MM-YYYY"),
      };
    } else if (col.field === "yearNumber") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => {
          return data?.yearNumber ? `Y${data.yearNumber}` : "--";
        },
      };
    } else if (col.field === "action") {
      return {
        ...col,
        maxWidth: 250,
        filter: false,
        pinned: "right",
        cellStyle: { textAlign: "center" },
        cellRendererFramework: MoreAction,
      };
    }
    return col;
  });
};
